import { request } from '@api/request'
import { ApiModule } from '@enums/ApiModules'
import { Level } from '@models/Level'
import { Variable } from '@models/Variable'
import { HistoryModelDate } from '@models/api/HistoryModelDate'
import { Dayjs } from 'dayjs'

export const historicalMeteo = {
  getDateList: async function (modelId: String): Promise<HistoryModelDate[]> {
    return request.get(`historicalMeteo?model=${modelId}`).then((response) => {
      return response.data
    })
  },

  getFireMapRequest: function (
    model: string,
    dateTime: Dayjs,
    outDate: Dayjs,
    variable: string
  ) {
    const params: AxiosParams = {
      model,
      dateTime: dateTime.utc().format('YYYY-MM-DDTHH:mm:ss'),
      variable
    }

    const output = outDate.utc().format('HH')
    if (output) {
      params.modelDate = outDate.format('YYYY-MM-DD')
    }

    return {
      url: `${request.defaults.baseURL}/historicalMeteo/getMap`,
      params
    }
  },

  getMapRequest: function (
    module: ApiModule,
    model: string,
    variable: string,
    datetime: Dayjs,
    outDate: Dayjs,
    level?: string,
    simplify = false
  ) {
    const params: AxiosParams = {
      module,
      model,
      dateTime: datetime.utc().format('YYYY-MM-DDTHH:mm:ss'),
      variable,
      smoothed: simplify
    }

    const output = outDate.utc().format('HH')
    if (output) {
      params.level = level || 'generic'
      params.output = output
    }

    if (outDate) {
      params.modelDate = outDate.format('YYYY-MM-DD')
    }

    return {
      url: `${request.defaults.baseURL}/historicalMeteo/getMap`,
      params
    }
  },

  getFireMap: function (
    dateTime: Dayjs,
    outDate: Dayjs,
    level: Level,
    variable: Variable
  ) {
    return this.getFireMapRequest(
      variable.reference,
      dateTime,
      outDate,
      level.reference
    )
  }
}
